module.exports = __webpack_public_path__ + "static/media/insurance.de8666b1.png";